import script from "./SettingsWeight.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsWeight.vue?vue&type=script&setup=true&lang=js"

import "./SettingsWeight.vue?vue&type=style&index=0&id=cfdb2c9c&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfdb2c9c"]])

export default __exports__